/**
 * 用于web端部分操作需要在开吧app中打开
 */
import Callapp from 'callapp-lib'
import { isKbApp } from '@/hooks/use-env'
import { jumpForAction } from '@/utils/kb-bridge'
import Vue from 'vue'

const callLib = new Callapp({
    scheme: {
        protocol: 'kbapp',
        host: 'api.kaiba315.com.cn',
    },
    universal: {
        host: 'ios.kaiba315.com.cn',
    },
    appstore: 'https://apps.apple.com/cn/app/%E5%BC%80%E5%90%A7/id1029288459',
    yingyongbao: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hz.czfw.app',
    fallback: 'https://page.kaiba315.com.cn',
})

/**
 *
 * @description 打开开吧app
 * @param {object} options 传参,支持action
 */
export const callKBApp = (options?: { action?: any; actionParams?: any }) => {
    if (isKbApp) {
        return jumpForAction(Vue.prototype, options?.action, options?.actionParams)
    }

    const param = ((value) => {
        const result = {}
        Object.keys(value).forEach((key) => {
            switch (Object.prototype.toString.call(value[key])) {
                case '[object Object]':
                case '[object Array]':
                    result[key] = encodeURIComponent(JSON.stringify(value[key]))
                    break
                default:
                    result[key] = value[key]
                    break
            }
        })
        return result
    })(options || {})

    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return callLib.open({
            param,
            path: 'app_page/common/iOSDownload.html',
        })
    } else {
        return callLib.open({
            param,
            path: '',
        })
    }
}
